<template>
    <a :href="report.urllink" target="_blank">
        <img v-if="report.img" style="width: 70px;height: 70px" :src="report.img">
        <img v-else src="../../assets/icons/report.png">
        <div class="text-container">
            <span v-html="report.title" class="date"></span>
            <span v-html="report.text" class="look"></span>
        </div>
    </a>
</template>

<script>
    export default {
        props: [
            'report'
        ],
        name: "reportblockview"
    }
</script>

<style scoped>
    a{
        text-decoration: none;
        padding: 30px 30px 40px;
        display: flex;
        align-items: center;
        max-width: 560px;
        width: 100%;
        background-color: rgb(255, 255, 255);
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px 0px;
        height: 184px;

    }

    a img{
        width: 110px;
        height: auto;
    }

    a .text-container{
        display: flex;
        flex-direction: column;
        justify-content: left;
        align-items: flex-start;
        padding-left: 30px;
    }

    a .text-container .date{
        font-size: 24px;
        line-height: 1.35;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 600;
        color: #000;
    }

    a .text-container .look{
        color: #ff8562;
        font-size: 16px;
        font-family: 'PT Sans',Arial,sans-serif;
        line-height: 1.55;
        font-weight: 700;
        text-decoration: none;
        cursor: pointer;
        display: inline-block;
    }
</style>